import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  StatusFormatter,
  columnsExportExcel,
  dateDefault,
  formLabelsTheme,
  formatDate,
  formatQuantity,
  formatterStatus,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  statusInboundFormatter,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editMaintenance,
  editMaintenanceConfirm,
  editMaintenanceSetstatus,
  fetchIdMaintenance,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectIdMaintenance,
  fetchMaintenance,
  fetchMaintenanceParty,
  selectMaintenanceParty,
  selectPageNoParty,
  selectPageSizeParty,
  selectTotalRecordParty,
  removeMaintenanceParty,
  fetchMaintenanceVehicle,
  selectMaintenanceVehicle,
  removeMaintenanceVehicle,
  fetchMaintenanceTransportations,
  selectMaintenanceTransportations,
  selectPageNoTransportations,
  selectPageSizeTransportations,
  selectTotalRecordTransportations,
  removeMaintenanceTransportations,
  editMaintenanceStarWorkflow,
  editMaintenanceAmmend,
  setPermisionList,
  setPermisionMaintenance,
  setPermisionInspect,
  setPermisionRepdiin,
  setPermisionRepdiout,
  fetchGenerateExcel
} from "./maintenanceSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { fetchCountryAll } from "../location/locationSlice";

import { Autocomplete } from "@material-ui/lab";
import { ModalCreateParty } from "../booking/ModalCreateParty";
import { ModalCreateVehicle } from "./ModalCreateVehicle";
import { VehicleUpload } from "./VehicleUpload";
import { VehicleUploadView } from "../booking/VehicleUploadView";
import { ModalLocationMasterRadio } from "../inbound/ModalLocationMasterRadio";
import { ModalPartyRadio } from "./ModalPartyRadio";
// import { ModalCreateVehicle } from "./ModalCreateVehicle";
// import { ModalCreateParty } from "./ModalCreateParty";
import { ModalCancel } from "./ModalCancel";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";
// import { ModalEditVehicle } from "./ModalEditVehicle";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const MaintenanceEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdMaintenance);
  const dataVehicle = useSelector(selectMaintenanceVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataMenuTab = useSelector(selectMenuTab);

  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);

  const [vehiclesFilter, setVehiclesFilter] = useState("");
  const [vehiclesFilterValue, setVehiclesFilterValue] = useState("");
  const [row, setRow] = useState(null);

  const [typeParty, setTypeParty] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [getData, setGetData] = useState(false);
  const [getDataParty, setGetDataParty] = useState(false);

  //
  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    job_date: {
      value: dateDefault,
      error: false,
      required: "Y",
    },
    ete: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    ets: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    service_class: {
      value: "",
      error: false,
      required: "Y",
    },
    workshop: {
      value: "",
      error: false,
      required: "N",
    },
    workshop_name: {
      value: "",
      error: false,
      required: "N",
    },
    factory: {
      value: "",
      error: false,
      required: "N",
    },
    factory_name: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
  });

  // formVehicle
  const [formVehicle, setFormVehicle] = useState({
    party_id: {
      value: "",
      error: false,
      required: "N",
    },
    party_name: {
      value: "",
      error: false,
      required: "N",
    },
    party_code: {
      value: "",
      error: false,
      required: "N",
    },
    timezone: {
      value: "",
      error: false,
      required: "N",
    },
  });

  // menu tab permision
  const [list, setList] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(fetchIdMaintenance(id));

      await dispatch(
        fetchMenuTab({
          menu_url: "/motor-pool/maintenance",
        })
      );

      await dispatch(
        fetchParameter({
          paramgroup_code: "DELIVERY_ARRANGEMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "ALL_PARTY",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        ...formValues,
        client: {
          value: dataId.client,
          error: false,
          required: "Y",
        },
        client_name: {
          value: dataId.client_name,
          error: false,
          required: "Y",
        },
        job_date: {
          value:
            dataId.job_date === null
              ? null
              : moment(dataId.job_date).format("YYYY-MM-DD"),
          error: false,
          required: "Y",
        },
        ets: {
          value:
            dataId.estimated_start === null
              ? null
              : moment(dataId.estimated_start).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        ete: {
          value:
            dataId.estimated_end === null
              ? null
              : moment(dataId.estimated_end).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        service_class: {
          value: dataId.service_class_name,
          error: false,
          required: "Y",
        },
        workshop: {
          value: dataId.workshop,
          error: false,
          required: "N",
        },
        workshop_name: {
          value: dataId.workshop_name === null ? "" : dataId.workshop_name,
          error: false,
          required: "N",
        },
        factory: {
          value: dataId.factory,
          error: false,
          required: "N",
        },
        factory_name: {
          value: dataId.factory_name === null ? "" : dataId.factory_name,
          error: false,
          required: "N",
        },
        remarks: {
          value: dataId.remarks,
          error: false,
          required: "N",
        },
      });

      dispatch(
        fetchMaintenanceVehicle({
          maintenance_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
  }, [dataId]);

  useEffect(() => {
    // Add number

    const pageBefore = pageSize * (pageNo - 1);
    const initData =
      dataVehicle === null
        ? []
        : dataVehicle.map((item, index) => {
            return {
              ...item,
              no: index + 1 + pageBefore,
            };
          });
    setTableDataVehicle(initData);
  }, [dataVehicle, pageSize, pageNo]);
  const [tableDataVehicle, setTableDataVehicle] = useState(dataVehicle);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Maintenance") {
          return dispatch(setPermisionMaintenance(item.permissions));
        }
        if (item.menu_name === "Inspection") {
          return dispatch(setPermisionInspect(item.permissions));
        }
        if (item.menu_name === "PDI-In") {
          return dispatch(setPermisionRepdiin(item.permissions));
        }
        if (item.menu_name === "PDI-Out") {
          return dispatch(setPermisionRepdiout(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      maintenance_id: id,
      client: formValues.client.value,
      job_date: formValues.job_date.value,
      // estimated_start: formValues.ets.value,
      // estimated_end: formValues.ete.value,
      workshop: formValues.workshop.value,
      factory: formValues.factory.value,
      services_class: formValues.service_class.value,
      remarks: formValues.remarks.value,
    };

    try {
      const response = await dispatch(editMaintenance(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const [showClient, setShowClient] = useState(false);
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [showShipper, setShowShipper] = useState(false);

  const [typeLocation, setTypeLocation] = useState("");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setVehiclesFilter("");
    } else {
      setVehiclesFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let params = {};

    params[vehiclesFilter] = vehiclesFilterValue;
    params.maintenance_id = id;
    params.pageNo = 1;
    params.pageSize = 10;

    try {
      const response = await dispatch(fetchMaintenanceVehicle(params));
      if (response.payload.data.status === 200) {
        window.scrollTo(0, 650);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};

      params[vehiclesFilter] = vehiclesFilterValue;
      params.maintenance_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchMaintenanceVehicle(params));
        if (response.payload.data.status === 200) {
          window.scrollTo(0, 650);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableDataVehicle(result);
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const handleDelete = async (e, row) => {
    const params = { maintenancevehicle_id: `${row.maintenancevehicle_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeMaintenanceVehicle({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(fetchIdMaintenance(id));
          await dispatch(
            fetchMaintenanceVehicle({
              maintenance_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {dataId.maintenance_status === "5110" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => handleDelete(e, row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Current Location",
      dataField: "current_location",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },

    {
      text: "Vehicle Status",
      dataField: "vehicle_status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  // modal Create vehicle
  const [showVehicle, setShowVehicle] = useState(false);
  const [showVehicleEdit, setShowVehicleEdit] = useState(false);
  const [showUpload, setShowUpload] = useState(false);

  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [showCancel, setShowCancel] = useState(false);

  const handleConfirm = async () => {
    const params = {
      maintenance_id: id,
    };
    try {
      const response = await dispatch(editMaintenanceConfirm(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleAmend = async () => {
    const params = {
      maintenance_id: id,
    };
    try {
      const response = await dispatch(editMaintenanceAmmend(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  // handle UPload File
  const [showUploadView, setShowUploadView] = useState(false);
  const [rowUpload, setRowUpload] = useState(null);
  const [rowUploadStatus, setRowUploadStatus] = useState(null);

  const handleDownloadUploadProgress = async (row) => {
    if (row == null || row.data == null || !(row.data instanceof Array) || row.data.length <= 0) {
      return;
    }

    const headers = Object.keys(row.data[0]);
    const shownIndexes = headers.map((h, i) => columnsExportExcel.find((c) => c.dataField === h) != null ? i : null).filter(x => x != null);

    const payload = {
      FileName: `Upload Result ${row.file_name}`,
      SheetName: 'Vehicle Maintenance',
      Data: [
        headers.filter((v, i) => shownIndexes.includes(i)).map((h) => columnsExportExcel.find((c) => c.dataField === h)?.text || h)
      ],
      ConditionalIndex: headers.filter((v, i) => shownIndexes.includes(i)).findIndex((h) => h === 'status_validate'),
      misc_header_id : row.misc_header_id,
      index_select : shownIndexes
    };
    // for (let i = 0; i < row.data.length; i++) {
    //   const rowData = Object.keys(row.data[i]).map((key) => {
    //     return row.data[i][key] || '';
    //   });
    //   payload.Data.push(rowData.filter((v, i) => shownIndexes.includes(i)));
    // }

    try {
      const response = await dispatch(fetchGenerateExcel(payload));
      
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Upload Result ${row.file_name}.xlsx`;
        link.click();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div className="d-flex flex-nowrap">
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUploadStatus(row.status);
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
        {
          row.status === 'Completed' && (
            <OverlayTrigger
              overlay={<Tooltip id="vehicle-download-tooltip">Download</Tooltip>}
            >
              <a
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
                onClick={() => handleDownloadUploadProgress(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Download.svg")} />
                </span>
              </a>
            </OverlayTrigger>
          )
        }
      </div>
    );
  };
  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  // modal party
  const [showParty, setShowParty] = useState(false);
  const [partyType, setPartyType] = useState(false);
  const [rowParty, setRowParty] = useState(null);

  const [selectedVehicle, setSelectedVehicle] = useState([]);

     const columnsWorkflow = [
    {
      text: "Activity",
      dataField: "activity",
    },

    {
      text: "Planned",
      dataField: "planned",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Pending",
      dataField: "pending",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Completed",
      dataField: "completed",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Cancelled",
      dataField: "cancelled",
      formatter: formatQuantity,
      align: "right",
    },

    {
      text: "Status",
      dataField: "status",
    },
  ];

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (dataId.maintenance_status === "5140" && list.includes(row.activity)) {
        if (row.activity === "Maintenance") {
          history.push(`/motor-pool/maintenance/workflow/edit/${id}`, 0);
        }
        if (row.activity === "Inspection") {
          history.push(`/motor-pool/maintenance/workflow/edit/${id}`, 1);
        }
        if (row.activity === "PDI-In") {
          history.push(`/motor-pool/maintenance/pdi/workflow/edit/${id}`, 0);
        }
        if (row.activity === "PDI-Out") {
          history.push(`/motor-pool/maintenance/pdi/workflow/edit/${id}`, 1);
        }
      }
    },
  };

  const handleStart = async () => {
    const params = {
      maintenance_id: id,
      maintenance_status: "5140",
    };
    try {
      const response = await dispatch(editMaintenanceStarWorkflow(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Maintenance : {dataId.maintenance_no}
                </p>
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest text-center  text-white">
                  Job Date :{formatDate(dataId.job_date)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  Client : {dataId.client_name}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white ">
                  Status :{" "}
                  {statusInboundFormatter(dataId.maintenance_status_name)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  <Dropdown>
                    <Dropdown.Toggle className="primary" id="dropdown-basic">
                      Action
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {dataId.maintenance_status === "5110" && (
                        <>
                          <Dropdown.Item onClick={(e) => setShowConfirm(true)}>
                            Confirm
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={(e) => {
                              setShowCancel(true);
                            }}
                          >
                            Cancel
                          </Dropdown.Item>
                        </>
                      )}

                      {dataId.maintenance_status === "5130" &&
                        dataId.is_amend === "Y" && (
                          <Dropdown.Item onClick={handleAmend}>
                            Amend
                          </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <ThemeProvider theme={formLabelsTheme}>
                <>
                  {/* Basic Detail */}
                  <div className="ml-2 mt-5">
                    <p className="font-weight-boldest">Basic Detail</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Job Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date"
                          value={formValues.job_date.value}
                          onChange={handleChange}
                          error={formValues.job_date.error}
                          helperText={
                            formValues.job_date.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                          disabled={
                            dataId.maintenance_status !== "5110" ? true : false
                          }
                        />
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Workshop"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.workshop_name.value}
                              readOnly
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setTypeParty("workshop");
                                    setShowParty(true);
                                    setGetDataParty(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                          {formValues.workshop_name.value !== "" && (
                            <Col xs={1} sm={1} md={1} lg={1}>
                              <div
                                style={{ marginTop: "22px", cursor: "pointer" }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,
                                    ["workshop"]: {
                                      ...formValues["workshop"],
                                      value: "",
                                    },
                                    ["workshop_name"]: {
                                      ...formValues["workshop_name"],
                                      value: "",
                                    },
                                  });
                                }}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/x-square.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <RedditTextField
                          label="Service Class"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          name="services_class"
                          value={dataId.services_class_name}
                          disabled
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Factory"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.factory_name.value}
                              readOnly
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setTypeParty("factory");
                                    setShowParty(true);
                                    setGetDataParty(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                          {formValues.factory_name.value !== "" && (
                            <Col xs={1} sm={1} md={1} lg={1}>
                              <div
                                style={{ marginTop: "22px", cursor: "pointer" }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,
                                    ["factory"]: {
                                      ...formValues["factory"],
                                      value: "",
                                    },
                                    ["factory_name"]: {
                                      ...formValues["factory_name"],
                                      value: "",
                                    },
                                  });
                                }}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/x-square.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <RedditTextField
                          label="Job Type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          name="services_class"
                          value={"Maintenance"}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>

                  <hr />

                  {/* Packages */}
                  <div>
                    <p className="font-weight-boldest">Packages</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Total Vehicles </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_vehicle}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Net Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_netweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <RedditTextField
                          
                          label="Remarks"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="remarks"
                          value={formValues.remarks.value}
                          inputProps={{ maxLength: 150 }}
                          onChange={handleChange}
                          disabled={
                            dataId.maintenance_status !== "5110" ? true : false
                          }
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Volume </b>
                          </Form.Label>
                          <Col sm={6}>
                            {" "}
                            <Form.Label className="mt-2">
                              <b>{dataId.total_volume}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Gross Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_grossweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  {/* handleSave */}
                  {dataId.maintenance_status === "5110" && (
                    <Row className="mt-6 justify-content-end">
                      <Button variant="primary" onClick={handleSave}>
                        Save
                      </Button>
                    </Row>
                  )}

                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">Vehicle</p>
                    <div className="d-flex justify-content-end">
                      <div className="p-2 mt-3">Search By</div>
                      <div className="p-2" style={{ width: "180px" }}>
                        {" "}
                        <Select
                          options={vehiclesOptions}
                          value={getValueOptions(
                            vehiclesFilter,
                            vehiclesOptions
                          )}
                          placeholder="Select"
                          onChange={handleChangeVehicles}
                          required
                        />
                      </div>
                      <div className="p-2">
                        <Form.Control
                          type="text"
                          placeholder=""
                          onChange={(e) =>
                            setVehiclesFilterValue(e.target.value)
                          }
                          value={vehiclesFilterValue}
                        />
                      </div>
                      <div className="p-2">
                        {" "}
                        <Button variant="primary" onClick={handleSearch}>
                          Search
                        </Button>
                      </div>
                    </div>

                    {/* table */}

                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      
                      keyField="vehicle_id"
                      data={tableDataVehicle}
                      columns={columns}
                      pagination={paginationFactory(options)}
                      onTableChange={handleTableChange}
                      hover
                    ></BootstrapTable>

                    {dataId.maintenance_status === "5110" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary mr-3"
                          onClick={(e) => {
                            setFileName("Upload Template File");
                            setFile(null);
                            setSelectedRows([]);
                            setTableData([]);
                            setShowUpload(true);
                          }}
                        >
                          Upload Vehicle
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={(e) => {
                            setGetData(true);
                            setShowVehicle(true);
                          }}
                        >
                          Add Vehicle
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">
                      Workflow of Maintenance Job
                    </p>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      
                      keyField="no"
                      data={
                        dataId.services_class === "MULTIPLE_PDI"
                          ? dataId.workFlowREPDIJobs
                          : dataId.workFlowMaintenanceJobs
                      }
                      columns={columnsWorkflow}
                      rowEvents={rowEvents}
                      hover
                    />

                    {dataId.maintenance_status === "5130" && (
                      <Row className="mt-6 justify-content-end">
                        <Button variant="outline-primary" onClick={handleStart}>
                          Start Workflow
                        </Button>
                      </Row>
                    )}
                  </div>

                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">File Upload Progress</p>
                    <Row>
                      <Col md={4}>
                        <BootstrapTable
                          wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          
                          keyField="no"
                          data={
                            dataId.tableUploadsMaintenanceVehicles === null
                              ? []
                              : dataId.tableUploadsMaintenanceVehicles
                          }
                          columns={columnsFile}
                          hover
                        />
                      </Col>
                    </Row>
                  </div>
                </>
              </ThemeProvider>
            </CardBody>
          </Card>

          {/* confrim  */}
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showConfirm}
            onHide={(e) => setShowConfirm(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Confirm Maintenance Job
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <p>
                  You are about to confirm Maintenance job No:{" "}
                  <b>{dataId.maintenance_no}</b>, <br />
                  this action cannot be undone!
                  <br />
                  Are you sure want to confirm this?
                </p>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={(e) => setShowConfirm(false)}
              >
                Close
              </Button>
              <Button variant="primary" onClick={handleConfirm}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          <ModalCreateVehicle
            isOpen={showVehicle}
            setShow={setShowVehicle}
            setFormValues={setFormVehicle}
            formValues={formVehicle}
            setFields={setFields}
            fields={fields}
            setGetData={setGetData}
            getData={getData}
            selectedRows={selectedVehicle}
            setSelectedRows={setSelectedVehicle}
          />

          <ModalPartyRadio
            isOpen={showParty}
            setShow={setShowParty}
            setFormValues={setFormValues}
            formValues={formValues}
            setFields={setFields}
            fields={fields}
            typeParty={typeParty}
            setTypeParty={setTypeParty}
            getData={getDataParty}
            setGetData={setGetDataParty}
          />

          <ModalCancel
            isOpen={showCancel}
            setShow={setShowCancel}
            id={id}
            name={dataId.maintenance_no}
          />

          <VehicleUpload
            isOpen={showUpload}
            setShow={setShowUpload}
            fileName={fileName}
            setFileName={setFileName}
            file={file}
            setFile={setFile}
            tableData={tableData}
            setTableData={setTableData}
            id={id}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
          <VehicleUploadView
            isOpen={showUploadView}
            setShow={setShowUploadView}
            setRowUpload={setRowUpload}
            rowUpload={rowUpload}
            rowUploadStatus={rowUploadStatus}
            setRowUploadStatus={setRowUploadStatus}
          />
        </>
      )}
    </>
  );
};
